/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import getNumberPrivateTrainingCenterActions, {
    getNumberPrivateTrainingCenterTypes,
} from '../../../redux/editique/getNumberPrivateTrainingCenter'
import { Get } from '../../../serveur/axios'

function* getNumberPrivateTrainingCenterSagas({ response }) {
    const { governorate, from, to, fromSecondary, toSecondary } = response

    let url = `/editique/number_private_center?`

    if (from) {
        url = `${url}&from=${from}`
    }

    if (to) {
        url = `${url}&to=${to}`
    }

    if (governorate) {
        url = `${url}&governorate=${governorate}`
    }

    if (fromSecondary) {
        url = `${url}&fromSecondary=${fromSecondary}`
    }

    if (toSecondary) {
        url = `${url}&toSecondary=${toSecondary}`
    }

    try {
        const res = yield Get(url)
        if (res.status === 200 || res.status === 201) {
            yield all([
                yield put(
                    getNumberPrivateTrainingCenterActions.getNumberPrivateTrainingCenterSuccess(
                        res.data
                    )
                ),
            ])
        } else {
            yield put(
                getNumberPrivateTrainingCenterActions.getNumberPrivateTrainingCenterFailure(
                    res.data.data
                )
            )
        }
    } catch (error) {
        yield put(
            getNumberPrivateTrainingCenterActions.getNumberPrivateTrainingCenterFailure(
                error
            )
        )
    }
}

export function* getNumberPrivateTrainingCenterSaga() {
    yield takeLatest(
        getNumberPrivateTrainingCenterTypes.GET_NUMBER_PRIVATE_TRAINING_CENTER_REQUEST,
        getNumberPrivateTrainingCenterSagas
    )
}
